import React, { Component } from 'react';
import assetWeb from '../assets/spider-web.png';
//import assetCandle from '../assets/candle.png'; //                 <img src={assetCandle} className="candle" alt="Candle" />

export class VotePageDecorativeElements extends Component {
    render() {
        return (
            <div>
                <img src={assetWeb} className="web-top" alt="web" />
            </div>
        )
    }
}